import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Icon_FoldedPaper_Teal, Icon_Heart_Teal, Icon_Person_Teal, Icon_Search_Teal } from '../common/CommonIcons';

const GridContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;

  width: 100%;
  background: #F9F9F9;
  padding:20px;
`

const GridItem = styled.div`
  display  : flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 4px;

  text-align: center;
  padding : 11.5px 0px;
  height: 82px;
  width: 100%;
  cursor: pointer;
  white-space: nowrap; /* 텍스트를 줄바꿈하여 표시 */
  border-radius: 10px;
  border: 1px solid #E4E4E4;
  background: #FFF;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.10);
  font-size: 14px;
  font-weight: 500;
`;

const options = [
  { text: "학교 탐색", image: <Icon_Search_Teal/>, route: "/searching-promotion-school" },
  { text: "홍보 결과 ", image: <Icon_FoldedPaper_Teal/>, route: "/promotion-result-list"},
  { text: "관심 표명자", image: <Icon_Heart_Teal/>, route: "/interested-person-management" },
  { text: "내 정보", image: <Icon_Person_Teal/>, route: "/my-info" },
];

const OptionsGrid = () => {
  const navigate = useNavigate();

  const handleClick = (route: string) => {
    if (route !== "#") {
      navigate(route);
    }
  };

  return (
    <GridContainer>
      {options.map((option, index) => (
        <GridItem key={index} onClick={() => handleClick(option.route)}>
          {option.image}
          {option.text}
        </GridItem>
      ))}
    </GridContainer>
  );
};

export default OptionsGrid;